let csrfToken = sessionStorage.getItem('wortgarten-csrf') || ''

export function setCsrf(token) {
  csrfToken = token || ''
  if (csrfToken) sessionStorage.setItem('wortgarten-csrf', csrfToken)
  else sessionStorage.removeItem('wortgarten-csrf')
}

export const getCsrfToken = () => csrfToken

export async function api(path, options = {}) {
  const headers = { ...(options.headers || {}) }
  if (options.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json'
  if (csrfToken && options.method && options.method !== 'GET') headers['X-CSRF-Token'] = csrfToken
  const response = await fetch(path, { credentials: 'same-origin', ...options, headers })
  const payload = response.headers.get('content-type')?.includes('application/json') ? await response.json() : await response.text()
  if (!response.ok) {
    const error = new Error(typeof payload === 'string' ? payload : payload.detail || '请求失败')
    error.status = response.status
    throw error
  }
  return payload
}

export const post = (path, body) => api(path, { method: 'POST', body: JSON.stringify(body ?? {}) })
export const put = (path, body) => api(path, { method: 'PUT', body: JSON.stringify(body ?? {}) })

export const studyDone = () => post('/api/today/study-done', {})

/* 成长徽章图鉴：{ collections, badges, newly_unlocked } */
export const getAchievements = () => api('/api/achievements')
